import styled from 'styled-components'

const PADDING_COLUMN_WIDTH = 115
const MINIMUM_CONTENT_WIDTH = 1024 + 2 * PADDING_COLUMN_WIDTH
const COLOR_DARK_BLUE = '#075892'
const COLOR_WHITE_TEXT = '#FEFEFE'
const COLOR_LIGHT_BLUE = '#94CCF3'
const COLOR_TEXT = '#0C1014'
const COLOR_HEADER_TEXT = '#45586B'

export const Container = styled.div`
  width: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`

export const TitleContainer = styled.div`
  width: 100%;
  position: sticky;
  left: 0;
`

export const NavigationContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  margin-inline: auto;
  padding: 0 ${PADDING_COLUMN_WIDTH}px;
  width: 100%;
  min-width: ${MINIMUM_CONTENT_WIDTH}px;
  border: 1px solid #c9c9cb;
  border-left-width: 0;
  border-right-width: 0;
  background: #dde5ed;
`

export const Content = styled.div<{
  $firstBackground: string
  $secondBackground: string
  $isHeader?: boolean
}>`
  width: 100%;
  display: grid;
  min-width: ${MINIMUM_CONTENT_WIDTH}px;
  min-height: 80px;
  margin-inline: auto;
  justify-content: center;
  align-items: center;
  background: ${({ $firstBackground, $secondBackground }) => `linear-gradient(
    to right,
    ${$firstBackground} 115px,
    ${$secondBackground} 115px,
    ${$secondBackground} 50%,
    ${$firstBackground} 50%,
    ${$firstBackground} calc(100% - 115px),
    ${$secondBackground} calc(100% - 115px),
    ${$secondBackground} 100%
  )`};
  color: ${({ $isHeader }) => `${$isHeader ? COLOR_HEADER_TEXT : COLOR_TEXT}`};
  padding: ${({ $isHeader }) =>
    `${$isHeader ? '0' : '80px'} ${PADDING_COLUMN_WIDTH}px`};
  grid-template-columns: ${({ $isHeader }) =>
    `${$isHeader ? '125px 291px 125px' : '1fr 291px 1fr'}`};
  gap: ${({ $isHeader }) => `${$isHeader ? '70px' : '0 4px'}`};
`

export const BalanceEdge = styled.div`
  min-height: 29px;
  width: 100%;
  background: ${COLOR_DARK_BLUE};
  color: ${COLOR_WHITE_TEXT};
  display: flex;
  justify-content: center;
  align-items: center;
`
type MovementArrowProps = {
  $value: number
  $min: number
  $max: number
  $type: 'in' | 'out'
}

const MOVEMENT_LABEL_ROOM = '200px'
const MOVEMENT_ARROW_MIN_WIDTH = '132px'
const MOVEMENT_ARROW_MAX_WIDTH = `calc(100% - ${MOVEMENT_LABEL_ROOM})`

export const MovementArrow = styled.div.attrs<MovementArrowProps>(
  ({ $value, $min, $max }) => ({
    style: {
      '--value': $value,
      '--min': $min,
      '--max': $max
    }
  })
)<MovementArrowProps>`
  --percentage: calc((var(--value) - var(--min)) / (var(--max) - var(--min)));

  width: calc(
    ${MOVEMENT_ARROW_MIN_WIDTH} + var(--percentage) *
      (${MOVEMENT_ARROW_MAX_WIDTH} - ${MOVEMENT_ARROW_MIN_WIDTH})
  );

  min-width: ${MOVEMENT_ARROW_MIN_WIDTH};
  max-width: ${MOVEMENT_ARROW_MAX_WIDTH};
  background: ${COLOR_DARK_BLUE};
  height: 15px;
  position: relative;

  ${({ $type }) =>
    $type === 'out' &&
    `
    left: -20px;
    margin-top: 8px;
  `}

  :after {
    content: '';
    display: block;
    position: absolute;
    z-index: 1;
    right: -20px;
    top: -8px;
    width: 20px;
    height: 31px;
    background-color: inherit;
    clip-path: polygon(0 0, 0% 100%, 100% 50%);
  }
`

export const Movement = styled.div<{ $type: 'in' | 'out' }>`
  display: flex;
  position: relative;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 25px 20px 50px;
  gap: 0 8px;
  flex-wrap: wrap;
  height: 100%;

  ${({ $type }) =>
    $type === 'out' &&
    `
    left: -4px;
    justify-content: flex-start;
  `}

  > :first-child {
    display: block;
    width: 100%;
    padding: 0 76px;
  }
`

export const BalanceCurrent = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 50px;
  background: ${COLOR_LIGHT_BLUE};
`

export const TotalMovement = styled.div`
  padding: 32px 40px 0;
`
